import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useActivateChassisMutation() {
  return useMutation<{ success: true }, { error: string }, { id: string }>({
    mutationFn: (values) => api.post('/arsenal/activate-chassis', values),
  });
}

export function useActivateWeaponMutation() {
  return useMutation<{ success: true }, { error: string }, { id: string }>({
    mutationFn: (values) => api.post('/arsenal/activate-weapon', values),
  });
}